"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                GlobalSearch_NavigationHelpText: "(Ctrl+/)",
                GlobalSearch_NavigationTooltip: "Search for a page",
                Search_NoResultsMessage: "There are no results for your query",
            }
        });
        var SearchBox = /** @class */ (function (_super) {
            __extends(SearchBox, _super);
            function SearchBox() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(SearchBox.prototype, "inputBoxElement", {
                get: function () {
                    if (!this._inputBoxElement) {
                        this._inputBoxElement = this.element.querySelector("input");
                    }
                    return this._inputBoxElement;
                },
                set: function (inputElement) {
                    this._inputBoxElement = inputElement;
                },
                enumerable: false,
                configurable: true
            });
            SearchBox.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // Variables
                this.HasFocus = $dyn.observable(false);
                this.mainMenu = "MainMenu";
                this.numberOfResults = 10;
                this.prevCompany = null;
                this.ResultList = $dyn.observableArray([]);
                this.ResultPickerOpen = $dyn.observable(false);
                this.selectedIndex = $dyn.observable(0);
                this.workspaceMenu = "NavPaneMenu";
                this.delayBeforeSearch = 500;
                // Functions
                this.flyoutClickSubscriber = function (options) {
                    if (!(options.clickTarget.tagName.toLowerCase() === "input" && $.contains(_this.element, options.clickTarget))) {
                        return $dyn.util.flyout.defaultFlyoutClickSubscriber(options);
                    }
                    return false;
                };
                this.focusin = function () {
                    $dyn.flyout.flyoutManager.removeAllFlyoutsAsync()
                        .done(function () {
                        // These nested timeouts are a hack to fix an IE issue (bug: 3683267)
                        // The underlying issue is that IE is firing multiple events and in a different order.
                        setTimeout(function () {
                            _this.inputBoxElement.select();
                            setTimeout(function () {
                                _this.openResultPicker();
                            }, 50);
                        }, 50);
                    });
                    _this.HasFocus(true);
                };
                this.focusInput = function () {
                    _this.inputBoxElement.focus();
                };
                this.focusout = function () {
                    _this.HasFocus(false);
                };
                this.keyDown = function (evt) {
                    var keycode = evt.which;
                    if (keycode === $dyn.ui.KeyCodes.downArrow || keycode === $dyn.ui.KeyCodes.upArrow) {
                        evt.preventDefault(); // Need to prevent the input control from changing focus in Chrome.
                    }
                    else if (keycode === $dyn.ui.KeyCodes.tab && _this.ShowResultPicker()) {
                        _this.closeResultPicker();
                    }
                    else if (keycode === $dyn.ui.KeyCodes.enter) {
                        // Prevent the keyDown from bubbling so the form level enter shortcut is prevented.
                        // See documentation on this behavior in $dyn.ui.Control constructor.
                        evt.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut.");
                    }
                    else if (keycode === $dyn.ui.KeyCodes.esc || keycode === $dyn.ui.KeyCodes.tab) {
                        var navSearch = $dyn.context($("#NavigationSearch")[0]);
                        var navigationBar = $dyn.ui.getNavBar();
                        // we want to collapse the search field but only if size indicates it should be hidden by default
                        if (($(navigationBar.element).hasClass("navBarSmall") ||
                            $(navigationBar.element).hasClass("navBarXSmall") ||
                            $(navigationBar.element).hasClass("navBarMedium")) &&
                            $dyn.value(navSearch.SearchFieldVisible())) {
                            // hide the input field
                            navSearch.SearchFieldVisible(false);
                            // set focus to the search button
                            document.getElementById("NavigationSearchExpandableControl").focus();
                        }
                        evt.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Esc shortcut.");
                    }
                };
                this.keyUp = function (evt) {
                    var keycode = evt.which;
                    var dropDownOpen = $dyn.value(_this.ShowResultPicker);
                    var dropDownShouldOpen = dropDownOpen;
                    if (keycode === $dyn.ui.KeyCodes.enter) {
                        _this.doNavigationSearchAsync(_this.inputBoxElement.value)
                            .done(function () {
                            _this.navigateToResultIndex($dyn.value(_this.selectedIndex));
                        });
                    }
                    else if ($dyn.ui.isPrintableKeyCode(keycode)) {
                        dropDownShouldOpen = true;
                        _this.ignoredSearchEvent();
                    }
                    else if (keycode === $dyn.ui.KeyCodes.downArrow) {
                        dropDownShouldOpen = true;
                        if (dropDownOpen) {
                            _this.nextItem();
                        }
                    }
                    else if (keycode === $dyn.ui.KeyCodes.upArrow) {
                        dropDownShouldOpen = true;
                        if (dropDownOpen) {
                            _this.previousItem();
                        }
                    }
                    if (dropDownShouldOpen && !dropDownOpen) {
                        // Only open the dropdown if it is not already open.
                        _this.openResultPicker();
                    }
                };
                var searchBoxThis = this;
                this.TextChanged = function (args) {
                    // fix up placeholder first
                    if (args.length === 1) {
                        if (args[0] === "") {
                            $(searchBoxThis.element).removeClass("noPlaceHolder");
                        }
                        else {
                            $(searchBoxThis.element).addClass("noPlaceHolder");
                        }
                    }
                    if (searchBoxThis.textChangedTimerId) {
                        window.clearTimeout(searchBoxThis.textChangedTimerId);
                        searchBoxThis.textChangedTimerId = undefined;
                    }
                    searchBoxThis.textChangedTimerId = window.setTimeout(function () {
                        searchBoxThis.doNavigationSearchAsync(args[0])
                            .done(function () {
                            searchBoxThis.textChangedTimerId = undefined;
                        });
                    }, searchBoxThis.delayBeforeSearch);
                };
                // Computeds
                this.ShowResultPicker = $dyn.computed(function () {
                    var pickerOpen = $dyn.value(_this.ResultPickerOpen);
                    var resultList = $dyn.value(_this.ResultList);
                    var resultListNotEmpty = resultList && resultList.length > 0;
                    return pickerOpen && (resultListNotEmpty || !!_this.lastQuery);
                }, function (newValue) {
                    _this.ResultPickerOpen(newValue);
                });
                this.ShowResultPicker.valueChanged.subscribe(function () {
                    if (!$dyn.value(_this.ShowResultPicker) && _this.inputBoxElement) {
                        _this.inputBoxElement.removeAttribute("aria-controls");
                        _this.inputBoxElement.removeAttribute("aria-activedescendant");
                    }
                    if ($dyn.value(_this.ShowResultPicker) && _this.inputBoxElement) {
                        _this.inputBoxElement.setAttribute("aria-controls", $dyn.value(_this.Id) + "_listbox");
                        _this.inputBoxElement.setAttribute("aria-activedescendant", $dyn.value(_this.Id) + "_listbox_item" + $dyn.value(_this.selectedIndex));
                    }
                    if ($dyn.value($dyn.user) && $dyn.value($dyn.user).Company) {
                        var currCompany = $dyn.user().Company();
                        if (_this.prevCompany !== currCompany) {
                            _this.prevCompany = currCompany;
                            if (_this.prevCompany && _this.lastQuery) {
                                var query = _this.lastQuery;
                                _this.lastQuery = null;
                                _this.doNavigationSearchAsync(query);
                            }
                        }
                    }
                });
                var $search = $(this.element).find(".searchBox-field");
                $dyn.observe($dyn.options(function () {
                    return { resultData: _this.ResultList, selectedIndex: _this.selectedIndex };
                }, this.Updating), function (option) {
                    var resultList = $dyn.value(option.resultData);
                    if (resultList.length === 0 && $dyn.value(_this.ResultPickerOpen)) {
                        $search.attr("aria-label", $dyn.label("Search_NoResultsMessage"));
                    }
                });
            };
            SearchBox.prototype.closeResultPicker = function () {
                this.ShowResultPicker(false);
            };
            SearchBox.prototype.NavigateToResult = function (result) {
                // Telemetry
                this.navigationToResultEvent(result);
                // Prevent blinking
                this.closeResultPicker();
                // route navigation through the navigation pane
                var navItem = this.createNavigationContext(result);
                $dyn.DynReact.ModuleStore.startNavigation(navItem);
            };
            SearchBox.prototype.createNavigationContext = function (result) {
                // Creates a context object that NavBar recognizes to
                // build the bread crumb. This needs to be replaced with
                // a path that can be parsed in the next iteration
                var menuItemParts = result.Tag.split(":");
                var navItem = {
                    Label: result.Name,
                    MenuItemName: menuItemParts[1],
                    MenuItemType: menuItemParts[0],
                    navigationFeatureName: "searchbox",
                    NavigationPath: result.AOTPath,
                };
                return navItem;
            };
            SearchBox.prototype.doNavigationSearchAsync = function (query) {
                var _this = this;
                var deferred = $.Deferred();
                query = query.trim();
                var isDoubleByte = $dyn.util.stringHasDoubleByte(query);
                if ((!isDoubleByte && query.length < 3) || (isDoubleByte && query.length < 2)) {
                    this.lastQuery = undefined;
                    this.ResultList([]);
                    deferred.resolve();
                    return deferred;
                }
                if (this.lastQuery && this.lastQuery === query) {
                    deferred.resolve();
                    return deferred;
                }
                var processResult = function (data) {
                    var e_1, _a;
                    // it we lost focus we should discard the results and close the picker
                    if (_this.HasFocus()) {
                        _this.currentSearchTelemetryInfo = { ResponseTime: performance.now() - ajaxSent, Query: query };
                        var results = [];
                        try {
                            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                                var item = data_1_1.value;
                                var path = item.Path;
                                if (path.length > 0) {
                                    var name_1 = path.pop();
                                    if (item.Source.toUpperCase() === _this.mainMenu.toUpperCase()) {
                                        // remove "Main Menu"
                                        path.shift();
                                    }
                                    else if (item.Source.toUpperCase() === _this.workspaceMenu.toUpperCase()) {
                                        path[0] = $dyn.label("NavigationPane_Workspaces");
                                    }
                                    var pathString = $dyn.shell.joinArrayWithChevron(path);
                                    results.push({ Name: name_1, Path: pathString, Tag: item.ItemDescription, AOTPath: item.AOTPath });
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.lastQuery = query;
                        _this.ResultList(results);
                    }
                    else {
                        _this.closeResultPicker();
                    }
                    deferred.resolve();
                };
                var ajaxSent = performance.now();
                this.sendQueryRequestAsync(query)
                    .done(processResult)
                    .fail(function () {
                    deferred.reject();
                });
                return deferred;
            };
            SearchBox.prototype.ignoredSearchEvent = function () {
                if (this.currentSearchTelemetryInfo) {
                    $dyn.telemetry.addNavigationSearchEvent(this.currentSearchTelemetryInfo.ResponseTime, this.currentSearchTelemetryInfo.Query, -1, "");
                    this.currentSearchTelemetryInfo = undefined;
                }
            };
            SearchBox.prototype.navigateToResultIndex = function (resultIndex) {
                var resultList = $dyn.value(this.ResultList);
                if (resultIndex < resultList.length) {
                    this.NavigateToResult(resultList[resultIndex]);
                }
            };
            SearchBox.prototype.navigationToResultEvent = function (result) {
                if (this.currentSearchTelemetryInfo) {
                    var resultIndex = $dyn.value(this.ResultList).indexOf(result) + 1; // We want to report 1-based index instead of 0-based
                    $dyn.telemetry.addNavigationSearchEvent(this.currentSearchTelemetryInfo.ResponseTime, this.currentSearchTelemetryInfo.Query, resultIndex, this.getResultDescription(result));
                    this.currentSearchTelemetryInfo = undefined;
                }
            };
            SearchBox.prototype.getResultDescription = function (result) {
                return result.Path + " (" + result.Tag + ")";
            };
            SearchBox.prototype.nextItem = function () {
                var nextIndex = $dyn.value(this.selectedIndex) + 1;
                var items = $dyn.value(this.ResultList);
                if (items && nextIndex < items.length) {
                    this.selectedIndex(nextIndex);
                    this.inputBoxElement.setAttribute("aria-activedescendant", $dyn.value(this.Id) + "_listbox_item" + nextIndex);
                }
            };
            SearchBox.prototype.openResultPicker = function () {
                if (this.HasFocus()) {
                    this.ShowResultPicker(true);
                    this.resetSelectedIndex();
                }
            };
            SearchBox.prototype.previousItem = function () {
                var previousIndex = $dyn.value(this.selectedIndex) - 1;
                if (previousIndex >= 0) {
                    this.selectedIndex(previousIndex);
                    this.inputBoxElement.setAttribute("aria-activedescendant", $dyn.value(this.Id) + "_listbox_item" + previousIndex);
                }
            };
            SearchBox.prototype.resetSelectedIndex = function () {
                var result = $dyn.value(this.Result);
                var items = $dyn.value(this.ResultList);
                var dropDownOpen = $dyn.value(this.ShowResultPicker);
                if (dropDownOpen && result && items) {
                    for (var i = 0; i < items.length; i++) {
                        if (items[i] === result) {
                            this.selectedIndex(i);
                            return;
                        }
                    }
                }
                // Set selectedIndex to 0 if resultList is null, or Result is not in ResultList
                this.selectedIndex(0);
            };
            SearchBox.prototype.sendQueryRequestAsync = function (query) {
                var _this = this;
                var deferred = $.Deferred();
                var userCompany = $dyn.user().Company();
                var userLanguage = $dyn.value($dyn.user().Language);
                var url = "/navigationsearch/dosearch?query=" + encodeURIComponent(query)
                    + "&numberOfResults=" + this.numberOfResults.toString()
                    + "&cmp=" + userCompany
                    + "&lng=" + userLanguage
                    + "&rootMenu=" + this.mainMenu
                    + "&rootMenu=" + this.workspaceMenu;
                $.ajax({
                    beforeSend: function (request) {
                        $dyn.util.activateLoadingAnimation(_this.element);
                        $dyn.serverForm.setCsrfToken(request);
                        var activityKey = $dyn.util.newGuid();
                        request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                        request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.activityKey, activityKey);
                        $dyn.browserActivity && $dyn.browserActivity.newInteraction(activityKey);
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("NavigationSearch");
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax(activityKey);
                    },
                    cache: false,
                    type: "GET",
                    url: $dyn.util.resolveVirtualPath(url)
                }).done(function (data) {
                    deferred.resolve(data);
                }).fail(function () {
                    deferred.reject();
                }).always(function () {
                    $dyn.util.removeLoadingAnimation(_this.element);
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                });
                return deferred;
            };
            return SearchBox;
        }($dyn.ui.Control));
        controls.SearchBox = SearchBox;
        SearchBox.prototype.ShowOnNavBar = $dyn.observable(true);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SearchBox.js.map
